import { DeviceType } from "../features/game-tracking/types/DeviceTypeEnum";
import { PlatformType } from "../features/game-tracking/types/PlatformTypeEnum";
import { utilUUID } from "../utils/utilUUID";
export var mockRegisterRequest = {
    clientId: utilUUID.uuidv4(),
    clientVersion: 10003,
    country: "US",
    deviceType: DeviceType.DESKTOP,
    deviceUniqueIdentifier: utilUUID.uuidv4(),
    locale: "en_US",
    platformType: PlatformType.WEB,
    trackingId: "853cd6cf5a5d4cf38eaa8ac8f758493f",
};
export var mockLoginRequest = {
    clientVersion: 10003,
    deviceType: DeviceType.DESKTOP,
    platformType: PlatformType.WEB,
    trackingId: "853cd6cf5a5d4cf38eaa8ac8f758493f",
};



//////////////////
// WEBPACK FOOTER
// ./src/__mock__/mockAuth.ts
// module id = 822
// module chunks = 3